import React from "react";
import styled from "styled-components";
import { ReactComponent as Crown } from "../../Assets/icons/subscription/crown.svg";
import { ReactComponent as Marked } from "../../Assets/icons/subscription/check.svg";
import { ReactComponent as Unmarked } from "../../Assets/icons/subscription/noCheck.svg";
import { useTranslate } from '@tolgee/react';
import { IOSSwitch } from "../GenericComponents/CustomSwitch";


const SubscriptionPlanPicker = ({
  payYearly,
  setPayYearly,
  subscribeTo,
  setSubscribeTo,
  sendInvites,
}) => {
  const { t } = useTranslate();
  const benefitsList = [
    {
      title: t('subscription_modal.benefit1Title'),
      description: t('subscription_modal.benefit1Description'),
    },
    {
      title: t('subscription_modal.benefitCallsTitle'),
      description: t('subscription_modal.benefitCallsDescription'),
    },
    {
      title: t('subscription_modal.benefit3Title'),
      description: t('subscription_modal.benefit3Description'),
    },
        {
      title: t('subscription_modal.benefitSelfTranslateTitle'),
      description: t('subscription_modal.benefitSelfTranslateDescription'),
    },

  ];
  const subscriptionPlans = [
    {
      title: t('subscription_modal.free').toUpperCase(),
      priceMonth: t('subscription_modal.free').toUpperCase(),
      priceYear: t('subscription_modal.free').toUpperCase(),
      benefits: [true, false, false, true],
    },

    {
      title: t('general.premium').toUpperCase(),
      priceMonth: "£3.99",
      priceYear: "£43.09",
      benefits: [true, true, true, true],
      crown: true,
      onClick: () => setSubscribeTo("premium"),
      value: "premium",
    },
  ];

  return (
    <SubscriptionPlanPickerWrapper>
      <InviteWrapper>
        <InviteTextWrapper>
          <SmallInfoText>
            {t('subscription_modal.invite_five')}
          </SmallInfoText>
          <HighlightedText>
            {t('subscription_modal.one_month_free_pro')}
          </HighlightedText>
        </InviteTextWrapper>
        <SendInviteBtn onClick={sendInvites}>
          {t('subscription_modal.send_invites')}
        </SendInviteBtn>
      </InviteWrapper>
      <PlansWrapper>
        <Benefits style={{ maxWidth: "150px" }}>
          <BenefitsCell>
            <TitleInfoText style={{ color: "rgba(149, 152, 157, 1)" }}>
              {t('subscription_modal.benefits')}
            </TitleInfoText>
          </BenefitsCell>
          {benefitsList.map((benefit, index) => (
            <BenefitsCell key={index} style={{ minWidth: "150px" }}>
              <TitleInfoText>{benefit.title}</TitleInfoText>
              <SmallInfoText>{benefit.description}</SmallInfoText>
            </BenefitsCell>
          ))}
          <BenefitsCell>
            <TitleInfoText>
              {t('subscription_modal.price').toUpperCase()}
            </TitleInfoText>
          </BenefitsCell>
        </Benefits>

        <PlanSelectors>
          {subscriptionPlans.map((subscriptionPlan, index) => (
            <PlanBtn
              key={subscriptionPlan.title}
              selected={subscriptionPlan.value === subscribeTo}
              onClick={subscriptionPlan.onClick}
            >
              <BenefitsCell>
                <PlanTitleWrapper>
                  {subscriptionPlan.crown && <CrownWrapper><Crown /></CrownWrapper>}
                  <TitleInfoText>{subscriptionPlan.title}</TitleInfoText>
                </PlanTitleWrapper>
              </BenefitsCell>
              {subscriptionPlan.benefits.map((benefit, index) => (
                <BenefitsCell>
                  <BenefitCheckWrapper>
                    {benefit ? <Marked /> : <Unmarked />}
                  </BenefitCheckWrapper>
                </BenefitsCell>
              ))}
              <BenefitsCell>
                <PlanPriceWrapper style={{ gap: 0 }}>
                  <PlanPriceText>
                    {payYearly && subscriptionPlan.priceYear}
                    {!payYearly && subscriptionPlan.priceMonth}
                  </PlanPriceText>

                  {subscriptionPlan.value && (
                    <PriceSmallInfoText>
                      {payYearly
                        ? `/${t('subscription_modal.year')}`
                        : `/${t('subscription_modal.month')}`}
                    </PriceSmallInfoText>
                  )}
                </PlanPriceWrapper>
              </BenefitsCell>
            </PlanBtn>
          ))}
        </PlanSelectors>
      </PlansWrapper>
      <PayTypeWrapper>
        <InviteTextWrapper>
          <HighlightedText style={{ fontSize: "16px", fontWeight: 600 }}>
            {t('subscription_modal.pay_anually').toUpperCase()}
          </HighlightedText>
          <SmallInfoText style={{ fontWeight: "400", }}>
            {t('subscription_modal.pay_text1')}
            <span>{t('subscription_modal.pay_text2')}</span>
            {t('subscription_modal.pay_text3')}
          </SmallInfoText>
        </InviteTextWrapper>
        <SavePercentWrapper>
          <SavePercentText>{t('pro_card.save')}</SavePercentText>
          <SavePercent>10%</SavePercent>
        </SavePercentWrapper>
        <IOSSwitch
          checked={payYearly}
          onChange={(e) => setPayYearly(e.target.checked)}
        />
      </PayTypeWrapper>
    </SubscriptionPlanPickerWrapper>
  );
};

export default SubscriptionPlanPicker;

const SubscriptionPlanPickerWrapper = styled.div`
  display: flex;
  flex-direction: column;
`;
const InviteWrapper = styled.div`
  padding: 15px 0;
  display: flex;
  width: 100%;
  border-top: 1px solid ${({ theme }) => theme.chat.dateSeparatorLine};
  border-bottom: 1px solid ${({ theme }) => theme.chat.dateSeparatorLine};
`;

const InviteTextWrapper = styled.div`
  display: flex;
  flex-direction: column;
  gap: 5px;
`;
const HighlightedText = styled.h3`
  font-size: 14px;
  font-weight: 500;
  line-height: 18px;
  color: ${({ theme }) => theme.premium_green};
`;
const TitleInfoText = styled.p`
  font-size: 14px;
  font-weight: 600;
  line-height: 18px;
  color: ${({ theme }) => theme.menu.primaryTextColor};
`;
const SmallInfoText = styled.p`
  font-size: 12px;
  font-weight: 400;
  line-height: 14px;
  color: ${({ theme }) => theme.menu.secondaryTextColor};
  span {
    font-weight: 600;
  }
`;

const SendInviteBtn = styled.button`
  display: flex;
  align-items: center;
  justify-content: center;
  border: none;
  background: none;
  font-size: 16px;
  font-weight: 500;
  line-height: 16px;
  text-align: center;
  color:  ${({ theme }) => theme.primaryButton.color};
  margin-left: auto;
  cursor: pointer;
`;

const PlansWrapper = styled.div`
  display: flex;
  gap: 3px;
  width: 100%;
  padding: 20px 0;
`;
const Benefits = styled.div`
  display: flex;
  flex-direction: column;
  gap: 15px;
`;

const BenefitsCell = styled.div`
  display: flex;
  flex-direction: column;
  gap: 3px;
  min-height: 50px;
  justify-content: center;
  width: 100%;
  min-width: 80px;
`;

const PlanSelectors = styled.div`
  display: flex;
  width: 100%;
`;

const PlanBtn = styled.button`
  display: flex;
  flex-direction: column;
  gap: 15px;
  border-radius: 12px;
  background: ${({ selected, theme }) => selected ? theme.planPicker.selectorColor : "none"};
  border: ${({ selected, theme }) => selected ? `1px solid ${theme.primaryButton.borderColor}` : "none"};
  overflow: hidden;
  width: 100%;
`;
const BenefitCheckWrapper = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;

  width: 100%;
svg{
color:${({ theme }) => theme.planPicker.unCheckedColor};
}
  &:last-child {
    border-right: none;
  }
`;
const PlanTitleWrapper = styled.div`
  display: flex;
  align-items: center;
  gap: 5px;
  justify-content: center;
`;
const PlanPriceWrapper = styled.div`
  display: flex;
  flex-direction: column;
  gap: 5px;
  align-items: center;
  justify-content: center;
`;
const PlanPriceText = styled.h3`
  font-size: 16px;
  font-weight: 600;
  line-height: 19px;
  color: ${({ theme }) => theme.premium_green};
`;
const PayTypeWrapper = styled.div`
  display: flex;
  align-items: center;
  width: 100%;
  padding: 20px 0;
  border-bottom: 1px solid ${({ theme }) => theme.chat.dateSeparatorLine};
  gap: 20px;
`;
const PriceSmallInfoText = styled.p`
  font-size: 11px;
  font-weight: 400;
  line-height: 14px;
  color: ${({ theme }) => theme.menu.primaryTextColor};
`;
const SavePercentWrapper = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;
  flex-direction: column;
  margin-left: auto;
`;
const SavePercent = styled.div`
  border-radius: 12px;
  padding: 3px 10px;
  background:${({ theme }) => theme.planPicker.selectorColor};
  display: flex;
  color: ${({ theme }) => theme.menu.primaryTextColor};
  font-size: 12px;
  font-weight: 600;
  line-height: 14px;
  text-align: center;
`;

const SavePercentText = styled.p`
  color:${({ theme }) => theme.menu.secondaryTextColor};
  font-size: 12px;
  font-weight: 400;
  line-height: 14px;
  text-align: center;
`;

const CrownWrapper = styled.div`
border-radius:100px;
width:24px;
height:24px;
display:flex;
justify-content:center;
align-items:center;
background:${({ theme }) => theme.menu.toggleFadedColor};
`